import { SortDirection } from '@material-ui/core'
import qs from 'querystring'

import api from 'common/api'

import { BulkContentItem, Content, ContentItemObject, ContentType, TopicFilter } from './Context'

export type BaseRequest = {
  scid: number
}

// TODO: Update with a better path for highlights ONLY
const overviewPath = (scid: number) => `/api/colleges/${scid}/content/sections?sectionType=CollegeOverview`

/** Highlights */

export type OverviewResponse = {
  // Only field we care about now
  BulletPoints: string[]
}
export const getHighlights = ({ scid }: BaseRequest) => {
  return api.get<OverviewResponse>(overviewPath(scid))
}

type HighlightUpdateRequest = BaseRequest & {
  oldData?: OverviewResponse
  newData?: OverviewResponse
}
export const updateHighlights = ({ scid, oldData, newData }: HighlightUpdateRequest) => {
  return api.patch(overviewPath(scid), oldData, newData)
}

/** Content */
type ContentRequestParams = {
  from?: number
  pageSize?: number
  direction?: SortDirection
  isHidden?: boolean | null
  sortBy?: string
  contentType?: string[]
  tags?: TopicFilter
}
export type ContentRequest = BaseRequest & {
  params?: ContentRequestParams
}
export const getContent = ({ scid, params = {} }: ContentRequest) => {
  return api.post<ContentRequestParams, Content>(`/api/colleges/${scid}/premium_content`, params)
}

export const getContentItem = ({ scid, id, type }: any) => {
  return api.get<any>(`/api/colleges/${scid}/premium_content/${type}/${id}`)
}

type UpdateContentRequestParams = {
  items: BulkContentItem[]
  isHidden?: boolean
}
type UpdateContentRequest = BaseRequest & UpdateContentRequestParams

export const updateContentVisibility = ({ scid, isHidden, items }: UpdateContentRequest) => {
  return api.post<UpdateContentRequestParams, null>(`/api/colleges/${scid}/premium_content/bulkToggleVisibility`, {
    isHidden,
    items,
  })
}

export const deleteContent = ({ scid, items }: UpdateContentRequest) => {
  return api.post<UpdateContentRequestParams, null>(`/api/colleges/${scid}/premium_content/bulkDelete`, {
    items,
  })
}

export type SaveOrderArgs = BaseRequest & {
  type: ContentType
  newOrder: string[]
  onError: () => void
}
export type UpdateOrderRequest = Omit<SaveOrderArgs, 'onError'>

export const updateOrderFromSortIndex = ({ scid, type, newOrder }: UpdateOrderRequest) => {
  return api.post(`/api/colleges/${scid}/content/sections/${type}/reorder`, { ids: newOrder })
}

// POST
const postProgramUrl = (scid: number) => `/api/colleges/${scid}/programs`
const postContentUrl = (scid: number) => `/api/colleges/${scid}/content/items`

// PATCH
const programUrl = (scid: number, id: string) => `/api/colleges/${scid}/programs/${id}`
const contentUrl = (scid: number, id: string) => `/api/colleges/${scid}/content/items/${id}`

type CreateContentItemParams = BaseRequest & {
  item: ContentItemObject
  type: ContentType
}
export const createContentItem = ({ scid, type, item }: CreateContentItemParams) => {
  let url
  switch (type) {
    case 'Programs':
      url = postProgramUrl(scid)
      return api.post(url, item)
    default: {
      const params = qs.stringify({ sectionType: type })
      url = `${postContentUrl(scid)}?${params}`
      return api.post(url, item)
    }
  }
}
type UpdateContentItemParams = BaseRequest & {
  type: ContentType
  oldData: ContentItemObject
  newData: ContentItemObject
}
export const updateContentItem = ({ scid, type, oldData, newData }: UpdateContentItemParams) => {
  let url
  switch (type) {
    case 'Programs': {
      url = programUrl(scid, oldData.Id)
      return api.patch(url, oldData, newData)
    }
    default: {
      const params = qs.stringify({ sectionType: type })
      url = `${contentUrl(scid, oldData.Id)}?${params}`
      return api.patch(url, oldData, newData)
    }
  }
}

type UpdateContentTypeParams = BaseRequest & {
  id: string
  oldContentType: ContentType
  newContentType: ContentType
}
export const updateContentPostType = ({ scid, id, oldContentType, newContentType }: UpdateContentTypeParams) => {
  return api.post(`/api/colleges/${scid}/premium_content/updateType`, {
    id,
    oldContentType,
    newContentType,
  })
}
